/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Corporate_Finance_Template_EditorInputs */

const en_corporate_finance_template_editor = /** @type {(inputs: Corporate_Finance_Template_EditorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Templates`)
};

const nl_corporate_finance_template_editor = /** @type {(inputs: Corporate_Finance_Template_EditorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Templates`)
};

/**
* | output |
* | --- |
* | "Templates" |
*
* @param {Corporate_Finance_Template_EditorInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const corporate_finance_template_editor = /** @type {((inputs?: Corporate_Finance_Template_EditorInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Corporate_Finance_Template_EditorInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_corporate_finance_template_editor(inputs)
	return en_corporate_finance_template_editor(inputs)
});